export default __webpack_public_path__ + "static/media/aqi_6.fc07b57a.svg";